import React from 'react';
import { Link } from 'react-router-dom';
import './Research.css';

const Research = () => {
  return (
    <div className="research-page">
      <div className="container">
        <h1 className="page-title">Research</h1>
        <p className="page-subtitle">Advancing solution-focused brief therapy through research and evidence-based practice</p>
        
        <div className="research-grid">
          <Link to="/research/definition" className="research-card">
            <div className="card-icon">📚</div>
            <h3>Definition and Research</h3>
            <p>Explore the foundations of solution-focused approaches and discover the research that supports these innovative therapeutic methods.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/research/grant" className="research-card">
            <div className="card-icon">💰</div>
            <h3>Research Grant</h3>
            <p>Learn about our research grant program that supports innovative studies in solution-focused brief therapy across Europe.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/resources" className="research-card">
            <div className="card-icon">📖</div>
            <h3>Resources</h3>
            <p>Access publications, books, articles, and useful links for solution-focused practitioners and researchers.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/sf-research" className="research-card">
            <div className="card-icon">🔬</div>
            <h3>SFA PubList by EBTA</h3>
            <p>Access our comprehensive database of solution-focused research publications, studies, and evidence-based findings.</p>
            <div className="card-arrow">→</div>
          </Link>

          <Link to="/taskgroups/research" className="research-card">
            <div className="card-icon">👥</div>
            <h3>Research Task Group</h3>
            <p>Meet our Research Task Group members and learn about their activities in supporting and promoting SF research.</p>
            <div className="card-arrow">→</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Research;
